import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CookieBanner } from "@/components/CookieBanner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import Clienti from "@/pages/Clienti";
import "@/App.css";

function App() {
  return (
    <BrowserRouter>
      <div className="grain-overlay" aria-hidden="true" />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/clienti-soddisfatti" element={<Clienti />} />
      </Routes>
      <CookieBanner />
      <Toaster theme="dark" position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
